import { $div, $txt, $icon, $input, $a, $tarea, $fun, $ } from './lib.js';
import { settings } from './settings.js';

import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { Sample } from './sample.js';

import { Message } from './message.js';

@customElement('sample-request')
export class SampleRequest extends LitElement {

  static styles = css`
:host { display: flex; flex-flow: column nowrap; color: white;  box-sizing: border-box;}
      input, textarea {
         background: black;
         color: white;
         border: 1px solid gray;
      }
      a {
         color: rgb(230,230,230);
      }

      .table {
          display: table;
      }
      .table-row {
          display: table-row;
      }
      .table-cell {
          display: table-cell;
          padding: 0.5em;
          border-bottom: 1px solid rgba(255,255,255, 0.3);
      }
      .sublabel {
          font-size: 0.85em;
          font-style: italic;
      }
      .item-label {
          max-width: 10em;
      }
      .part {
          border: 0px solid rgba(255,255,255,0.5);
          border-radius: 0.5em;
          margin: 1em;
          margin-bottom: 2em;
          padding: 1em;
          position: relative;
          display: flex;
          flex-direction: column;
          gap: 1em;
          padding-top:2em;
      }
      .required {
          display: inline;
      }
      .required::after {
          display: inline;
          color: rgb(255,0,0);
          font-weight: bold;
          content: ' *';
      }
      .other_input2 {
          width: auto;
          flex-grow: 2;
      }
      input[type="button"] {
        font-size: 1.1em;
        cursor: pointer;
        padding: 0.2em;
        border-radius: 0.2em;
        background: rgb(120,120,120);
        border: 1px solid #ffffff50;
      }
      input[type="reset"] {
        font-size: 1.1em;
        cursor: pointer;
        padding: 0.2em;
        border-radius: 0.2em;
        border: 1px solid white;
        border: 1px solid #ffffff50;
        background: rgb(120,120,120);
      }
      input[type="text"] {
          width: 100%;
          height: 1.75em;
      }
      input[type="email"] {
          width: 100%;
          height: 1.75em;
      }
      input[type="tel"] {
          width: 100%;
          height: 1.75em;
      }
      input[type="number"] {
          width: 100%;
          height: 1.75em;
      }

      .other_input {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-content: stretch;
          gap: 1em;
      }
      .rock_core {
          border-radius: 0.5em;
          display: flex;
          flex-flow: column nowrap;
          margin-top: 1em;
      }
      .part-label {
          position: absolute;
          background: black;
          color: white;
          font-size: 1.3em;
          font-weight: bold;
          top: -10px;
          left: 0px;
          padding: 0.2em;
          padding-left: 0.5em;
          padding-right: 0.5em;
          border: 0px solid rgba(255,255,255,0.5);
border-bottom: 1px solid white;
width: 100%;
      }
      form {
          position: relative;
          width: 100%;
      }
      .title {
         font-weight: bold;
         font-size: 1.4em;
      }
.textbox-label { padding: 0.3em; }
.close {
   position: sticky;
   top: 0;
   display: flex;
   justify-content: right;
   font-size: 1.5em;
   border: 0px solid lime;
   padding-right: 0.5em;
   cursor: pointer;
   z-index: 6371;
align-self: flex-end;
width: 100px;
}
.pl-4 {
margin: 0.3em;
}
summary { font-weight: bold; }
`;

  form_cancel(_ev: Event) {
    this.dispatchEvent(new Event('form-cancel', { bubbles: true, composed: true }))
  }

  form_submit(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    const form = this.shadowRoot!.querySelector('form');
    if (!form)
      return false;
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }
    let data = new FormData(form);
    let post_data: { [key: string]: any } = { samples: [] };
    for (const sample of this.samples) {
      const name = sample.Full_Sample_Name;
      const id = `id_${name}_`;
      const IGSN = sample.IGSN
      const subsample = sample.sub_sample_id != undefined
      let sample_meta: { [key: string]: any } = { name, IGSN, subsample };
      let remove = [];
      for (const [key, value] of data.entries()) {
        if (key.startsWith(id)) {
          const k = key.replace(id, "");
          sample_meta[k] = value;
          remove.push(key);
        }
      }
      post_data.samples.push(sample_meta);
      remove.forEach(key => data.delete(key));
      data.delete(`id_${name}`)
    }
    for (const [key, value] of data.entries()) {
      post_data[key] = value;
    }
    this.send_request(post_data);
  }

  async send_request(post_data: any) {
    let ret: any = {};
    new Message('Sending sample request', { duration: 1 })

    try {
      const url = "/requests";
      const res = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(post_data),
      });
      ret = await res.json();
    } catch (error) {
      console.log("Error: ", error)
      //alert("An error occurred while sending your request", error);
      new Message(`${error}`, { type: 'error' })
      return false;
    }
    let timeout = 10
    let msg = ""
    let m: any = null
    if (ret.email == "ok") {
      timeout = 3
      msg = 'Request completed successfully '
      m = new Message(msg);
    } else {
      timeout = 10
      msg = `Request completed successfully. Email had difficulties, contact mgsl@etal.uri.edu. Your completed request page will show soon `
      m = new Message(msg, { duration: timeout })
    }
    let t = timeout
    setInterval(() => {
      t -= 1;
      if (m) { m.set_message(msg + `(${t} seconds)`) }
    }, 1000)
    setTimeout(() => {
      location.href = `/requests/complete/${ret.uid}-${ret.key}.html`;
    }, timeout * 1000);
  }

  @property({ type: Object })
  settings: { [key: string]: any };

  @property({ type: Array })
  samples: Sample[];

  on_input(ev: Event) {
    const el = ev.target as HTMLInputElement;
    const name = el.name
    if (el.type == "checkbox" || el.type == "radio") {
      settings.data[name] = el.checked
      this.settings[name] = el.checked
      settings.save()
    } else {
      settings.data[name] = el.value
      this.settings[name] = el.value
      settings.save()
    }
    console.log(name, settings, this.settings[name], settings.data[name])
  }

  constructor(samples: Sample[]) {
    super();
    this.samples = samples;
    this.settings = {};
    settings.keys().forEach((key: string) => this.settings[key] = settings.data[key]);
  }

  sample_is_core(sample: Sample) {
    return sample.Object_Type.includes("Core");
  }
  sample_is_rock(sample: Sample) {
    return !(this.sample_is_core(sample));
  }

  num_rocks() {
    return this.samples.filter((s: Sample) => this.sample_is_rock(s)).length
  }
  num_cores() {
    return this.samples.filter((s: Sample) => this.sample_is_core(s)).length
  }

  rocks() {
    const rows = [];
    const items = this.samples.filter((s: Sample) => this.sample_is_rock(s));
    if (!items.length)
      return '';
    rows.push(html`<div class="part-label">Rocks</div>`)
    rows.push(...items.map((item: Sample) => this.rock_form(item, undefined)));
    return html`<div class="part" id="rocks">${rows}</div>`;
  }
  cores() {
    const rows = [];
    const items = this.samples.filter((s: Sample) => this.sample_is_core(s));
    if (!items.length)
      return '';
    rows.push(html`<div class="part-label">Cores</div>`)
    rows.push(...items.map((item: Sample) => this.rock_form(item, undefined)))
    return html`<div class="part" id="cores">${rows}</div>`;
  }

  copy_to_others(ev) {
    ev.preventDefault()
    const el = ev.target
    const name = el.dataset.name

    let sample = this.samples.find((s: Sample) => s.Full_Sample_Name == name)
    if (!sample) {
      return
    }
    const is_rock = this.sample_is_rock(sample)
    let src_id = `id_${sample.Full_Sample_Name}`
    let skips = ["name", "type"]
    const inputs = [...this.shadowRoot.querySelectorAll(`[id^=${src_id}_]`)]
    for (const s of this.samples) {
      if (s.Full_Sample_Name == sample.Full_Sample_Name) { // skip current sample
        continue
      }
      if (this.sample_is_rock(s) != is_rock) {
        continue
      }
      const dst_id = `id_${s.Full_Sample_Name}`
      for (const src of inputs) {
        let kind = src.id.replace(src_id + "_", "")
        if (skips.includes(kind)) { // skip some fields
          continue
        }
        let dst = this.shadowRoot.getElementById(`${dst_id}_${kind}`)
        if (dst) {
          dst.value = src.value
          this.on_input({ target: dst })
        }
      }
    }
  }

  render() {
    this.settings.rock = (this.num_rocks() > 0)
    this.settings.cored_sediment = (this.num_cores() > 0)
    return html`
<link rel="stylesheet" href="font-awesome-4.7.0/css/font-awesome.min.css">
<div class="close" @click=${this.form_cancel} title="Close form"><i class="fa fa-times" aria-hidden="true"></i></div>

<div style="position: relative;">
  <div class="title">MGSL Sample Request</div>
  <h4>Use this form to submit a sample request to the URI/GSO Marine Geological Samples Laboratory</h4>
  <form>
    <div class="table part">
      <div class="part-label">Requestor Contact</div>
      <div class="table">
        <div class="table-row">
          <div class="table-cell item-label">
            <label for="requestor">
              Requestor's Name <div class="required"></div>
            </label>
          </div>
          <div class="table-cell">
            <input id="requestor" name="requestor" type="text" .value=${this.settings.requestor} required @input=${this.on_input}>
          </div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            <label for="pi">
              Principal Investigator's (PI) Name <div class="required"></div>
              <div class="sublabel">
                If you are a student, this is your advisor</div>
            </label>
          </div>
          <div class="table-cell">
            <input id="pi" name="pi" type="text" required value=${this.settings.pi} @input=${this.on_input}>
          </div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            Email<div class="required"></div>
          </div>
          <div class="table-cell">
            <input id="email" name="email" type="email" required value=${this.settings.email} @input=${this.on_input}></div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            Position / Job Title<div class="required"></div>
          </div>
          <div class="table-cell">
            <input id="position" name="position" type="text" required value=${this.settings.position} @input=${this.on_input}></div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
             ORCID (if known, see <a href="https://orcid.org" target="_blank">orcid.org</a>)
          </div>
          <div class="table-cell">
            <input id="position" name="orcid" type="text" value=${this.settings.orcid} @input=${this.on_input}></div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            <label for="institution">
              PI/Requestor Institution
              <div class="required"></div>
              <div class="sublabel">
                Please list both if they are different
              </div>
            </label>
          </div>
          <div class="table-cell">
            <input id="institution" name="institution" type="text" required value=${this.settings.institution} @input=${this.on_input}>
          </div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            <label for="address">
              Name and address for shipment
              <div class="required"></div>
            </label>
          </div>
          <div class="table-cell">
            <input id="address" name="address" type="text" required value=${this.settings.address} @input=${this.on_input}>
          </div>
        </div>

        <div class="table-row">
          <div class="table-cell item-label">
            <label for="phone">
              Contact phone number for shipment
              <div class="required" ></div>
            </label>
          </div>
          <div class="table-cell">
            <input id="phone" name="phone" type="tel" required value=${this.settings.phone} @input=${this.on_input}>
          </div>
        </div>
      </div>
    </div>

    <div class="part" style="display: none;">
      <div class="part-label">Request Stats</div>
      <label>
        This request is for (check all that apply)
        <div class="required"></div>
      </label>
      <div>
<input id="rock" name="rock" type="checkbox" ?checked=${this.settings.rock} @change=${this.on_input}>
<label for="rock"> Rock</label>
      </div>
      <div>
<input id="glass" name="glass" type="checkbox" ?checked=${this.settings.glass} @change=${this.on_input}>
<label for="glass=">Glass</label>
      </div>
      <div>
<input id="cored_sediment" name="cored_sediment" type="checkbox" ?checked=${this.settings.cored_sediment} @change=${this.on_input}>
<label for="cored_sediment">Cored Sediment</label>
      </div>
      <div>
<input id="surface_sediment_grab" name="surface_sediment_grab" type="checkbox" ?checked=${this.settings.surface_sediment_grab} @change=${this.on_input}>
<label for="surface_sediment_grab">Surface Sediment Grab</label>
      </div>
      <div class="other_input">
<div><input id="other" name="other" type="checkbox" ?checked=${this.settings.other} @change=${this.on_input}/>
<label for="other">Other<label></div>
<input class="other_input2" name="other_text" id="other_text" type="text" style="width: auto" value=${this.settings.other_text} @input=${this.on_input}>
      </div>
      <div class="other_input">
        Number of rock or glass samples in this request (Computed):
<input class="other_input2" name="rock_glass_num" id="rock_glass_num" value=${this.num_rocks()} type="number"/>
      </div>
      <div class="other_input">
        Number of sediment samples in this request (Computed):
<input class="other_input2" name="sediment_num"  id="sediment_num" value=${this.num_cores()} type="number"/>
      </div>
    </div>

    <div class="part">
      <div class="part-label">Request Description</div>
      <div>
        <div class="textbox-label">
          Please describe the general goals of your study and data sets to be collected
          <div class="required"></div>
        </div>
<textarea id="goals" name="goals" cols="72" rows="5" @input=${this.on_input}>${this.settings.goals}</textarea>
      </div>
      <div>
        <div class="textbox-label">
          Please describe the general type and quantity of material needed (required):
          <div class="required"></div>
        </div>
<textarea id="material" name="material" cols="72" rows="5" @input=${this.on_input}>${this.settings.material}</textarea>
      </div>
      <div>
        <div>
          <div>Is this study related to a funded research project?</div>
<input type="checkbox" id="funded" ?checked="${this.settings.funded}" name="funded" @change=${this.on_input}>
<label for="funded">Funded</label>
        </div>
        <div>If you answered yes above, please provide the agency name, program, and award number:</div>
<input id="funding_info" name="funding_info" type="text" value=${this.settings.funding_info} @input=${this.on_input}>
      </div>
    </div>

    ${this.rocks()}
    <!-- For rocks or glass, include the full sample name (e.g., EN113 13D-1g), the material type (bulk rock, glass, etc.), the quantity needed (use either mass or dimensions), and any notes for the repository staff. -->

   ${this.cores()}
      <!--For sediments, include the full name of the core (e.g., TR163-22), a description of the material you plan to study (e.g., planktonic forams, bulk sediment, size fraction, etc.), top and bottom of the depth interval to sample (in cm) or the spacing and interval to be covered, the sample size needed (in cc), and any notes for the repository staff (e.g., is it ok to shift intervals up or down, specific handling, etc.).
        -->

    <div class="part">
      <div class="part-label">Terms and Conditions</div>
      <div>Terms of Use:</div>
      By checking the button below, I agree to the following terms of use:
<ol class="ml-4">
<li class="pl-4"> When I publish data from any MGSL samples in the conduct of my research,
I will acknowledge the MGSL and its supporting agencies with the following statement:
<div style="padding:1em;">
National Science Foundation grant OCE-2311259 and the NOAA Cooperative Institute for Ocean Exploration
provide support for the curation and distribution of geological samples at the
Marine Geological Samples Laboratory, University of Rhode Island.
</div>
<li class="pl-4">
I will share back reference information and/or copies of any publications reporting data from these samples to the repository at <a href="mailto:mgsl@etal.uri.edu" class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">mgsl@etal.uri.edu</a>.
<li  class="pl-4">I will acknowledge the MGSL in any oral/poster presentations by using the <a href="MGSL_Rect.png" class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">MGSL Logo</a>
<center style="margin-top:0.5em;">
<a href="MGSL_Rect.png" target="_blank"><img src="MGSL_Rect.png" height="96"/></a>
</center>

<li class="-pl-4">At the completion of my study, I will return any unused materials from this request to the MGSL at the following address:
<ul style="list-style-type: none;">
<li>	URI Marine Geological Samples Laboratory
<li>	Graduate School of Oceanography
<li>	20 Receiving Rd.
<li>Narragansett, RI 02882
</ul>
MGSL will cover the costs of return shipments upon request to <a href="mailto:mgsl@etal.uri.edu">mgsl@etal.uri.edu</a>
      </ol>
      <div>
        <input type="checkbox" name="agreed_to_terms" id="agreed_to_terms" required>
<label for="agreed_to_terms">I agree to the "Terms of Use"</label>
<div class="required"></div>
      </div>
    </div>
    <div style="display: flex; flex-flow: row nowrap; justify-content: center; width: 100%; gap: 1em; padding-bottom: 3em;">
      <input type='button' id="form_submit" value='Submit' @click=${this.form_submit}></button>
      <input type='reset' id="form_cancel" value='Cancel' @click=${this.form_cancel}></input>
    </div>
  </form>
</div>
`;
  }



  rock_form(sample: Sample, _form: any) {
    //console.log('form', form)
    const name = sample.Full_Sample_Name;
    const type = (this.sample_is_core(sample)) ? "core" : "rock";
    const id = `id_${name}`;
    const el = $div({ class: "rock_core" });
    // Title / Toggle
    const title = $div({ id: `${id}-toggle`, class: "core-show-hide" });
    const title_items = $div({ style: "padding: 0.5em; font-weight: bold;" });
    title_items.add($txt(name));
    const toggle = $div({ style: "font-size: 1.5em; display: inline" });
    toggle.add($icon("caret-up", { id: `${id}-hide`, style: "display: inline" }))
    toggle.add($icon("caret-down", { id: `${id}-show`, style: "display: inline" }))
    title_items.add(toggle);
    title.add(title_items);
    el.add(title);

    const head = html`
<div class="rock_core">
  <div id="${id}-toggle" class="core-show-hide">
    <div style="padding: 0.5em; font-weight: bold">
      ${name}
    </div>
  </div>
</div>
`;

    const rock_input = [
      {
        label: "Rock Name",
        sublabel: "Name of the rock including cruise, dredge or grab number, group number and rock number (if applicable)",
        inputs: [
          { id: `${id}_name`, type: "text", required: true, value: name, readonly: true },
          { id: id, type: "hidden", value: id },
          { id: `${id}_type`, type: "hidden", value: "rock" },
        ]
      },
      {
        label: "Purpose",
        sublabel: "What you plan to measure on the sample (e.g. major elements, radiogenic isotopes, etc.) - try to be specific",
        inputs: [{ id: `${id}_purpose`, type: "text", required: true }]
      },
      {
        label: "Material",
        sublabel: "What part of the rock you need - e.g., bulk pillow interior, glass, thin section tab with details of the cut needed",
        inputs: [{ id: `${id}_material`, type: "text", required: true }]
      },
      {
        label: "Sample Size",
        sublabel: "in grams",
        inputs: [{ id: `${id}_sample_size`, type: "text", required: true }]
      },
      {
        label: "Sample Dimensions",
        sublabel: "Please provide units",
        inputs: [{ id: `${id}_sample_dimensions`, type: "text", required: true }]
      },
      {
        label: "Comments",
        sublabel: "Include handling instructions, other details on sub-sampling, etc.",
        inputs: [{ id: `${id}_comments`, type: "text", required: false, cols: "72", rows: "5" }]
      }
    ];

    const core_input = [
      {
        label: "Core Name",
        sublabel: "Name of the core including cruise and core name",
        required: true,
        inputs: [
          { id: `${id}_name`, type: "text", required: true, value: name, readonly: true },
          { id: id, type: "hidden", value: id },
          { id: `${id}_type`, type: "hidden", value: "core" }
        ]
      },
      {
        label: "Purpose",
        sublabel: "What you plan to measure on the sample (e.g. 18O isotopes, Mg/Ca) - try to be specific",
        inputs: [{ id: `${id}_purpose`, type: "text", required: true }]
      },
      {
        label: "Material",
        sublabel: "What will you actually use, e.g. whole sample, or seive for a specific fraction (e.g. Planktic forams? Wood? Organics?) Be specific",
        inputs: [{ id: `${id}_material`, type: "text", required: true }]
      },
      {
        label: "Sample Top (cm)",
        sublabel: "Upper depth of interval sampled",
        inputs: [{ id: `${id}_sample_top`, type: "text", required: true }]
      },
      {
        label: "Sample Bottom (cm)",
        sublabel: "Lower depth of interval sampled",
        inputs: [{ id: `${id}_sample_bottom`, type: "text", required: true }]
      },
      {
        label: "Sampling Interval (cm)",
        sublabel: "How often to sample along the core",
        inputs: [{ id: `${id}_sample_interval`, type: "text", required: false }]
      },
      {
        label: "Sample Size (cc)",
        sublabel: "In cubic centimeters (cc) - 5 grams @ 10 cc",
        inputs: [{ id: `${id}_sample_bottom`, type: "text", required: true }]
      },
      {
        label: "Comments",
        sublabel: "Include handling instructions, whether moving samples up or down is appropriate, etc...",
        inputs: [{ id: `${id}_comments`, type: "text", required: false, cols: "72", rows: "5" }]
      }
    ];
    const input = (type == "rock") ? rock_input : core_input;


    const body = html`
<details open><summary>${name}</summary>

<div style="display: flex; flex-flow: row nowrap; justify-content: flex-end;">
<button id="${id}-copy" data-name="${name}" @click=${this.copy_to_others}>Copy details to all other ${type}s</button>
</div>
<div class="rock_core" id="${id}-table"><div class="table">${this.make_table(input)}</div>${this.make_comments(input)}</div>
</details>
`;
    return [body];
  }
  make_comments(rows: any[]) {
    const comms = rows.find((x: any) => x.label == "Comments");
    if (!comms)
      return '';
    comms.inputs[0].name = (comms.inputs[0].name) ? comms.inputs[0].name : comms.inputs[0].id;
    const r = comms.inputs[0]
    return html`<div class="xtable-cell"><div style="padding: 1em">
<textarea id="${r.id}" name="${r.id}" type="text" cols=${r.cols} rows=${r.rows}></textarea></div></div>
`;
  }

  table_input(r: any) {
    let out = [];
    for (const ri of r.inputs) {
      ri.name = (ri.name) ? ri.name : ri.id;
      let value = (ri.value) ? ri.value : "";
      if (this.settings[ri.id]) {
        value = this.settings[ri.id]
      }
      let inp
      if (ri.readonly) {
        inp = html`<input readonly id="${ri.id}" name="${ri.name}" type=${ri.type} required=${ri.required} value="${value}"  />`;
      } else {
        inp = html`<input id="${ri.id}" name="${ri.name}" type=${ri.type} required=${ri.required} value="${value}" @input=${this.on_input} />`;
      }
      out.push(inp);
    }
    return out;
  }

  make_table(rows: any[]) {
    const out = rows.map(r => {
      const required = r.inputs.some((x: any) => x.required)
      let req = (required) ? html`<div class="required"></div>` : '';
      if (r.label != "Comments") {
        return html`
<div class="table-row">
<div class="table-cell item-label">${r.label}${req}<div class="sublabel">${r.sublabel}</div></div>
<div class="table-cell">${this.table_input(r)}</div>
</div>`
      } else {
        return html`
<div class="table-row">
<div class="table-cell item-label">${r.label}${req}<div class="sublabel">${r.sublabel}</div></div>
</div>`
      }
    });
    return out;
  }

}
